export const MODULE_NAME = 'banners';
